import type { BombDropEvent, BombPlantedEvent } from "@/lib/demo-parser";

export function drawPlantedBomb(
  ctx: CanvasRenderingContext2D,
  bombsPlanted: BombPlantedEvent[],
  roundStartTick: number,
  frameTick: number,
  toScreenX: (x: number) => number,
  toScreenY: (y: number) => number
) {
  const roundBombs = bombsPlanted.filter(
    (b) => b.tick >= roundStartTick && b.tick <= frameTick
  );
  if (roundBombs.length === 0) return;

  const bomb = roundBombs[roundBombs.length - 1];
  const sx = toScreenX(bomb.x);
  const sy = toScreenY(bomb.y);
  const pulse = 0.6 + Math.sin(Date.now() * 0.006) * 0.4;

  // Outer glow
  ctx.fillStyle = `rgba(255, 130, 0, ${pulse * 0.25})`;
  ctx.beginPath();
  ctx.arc(sx, sy, 24, 0, Math.PI * 2);
  ctx.fill();

  // Mid ring
  ctx.strokeStyle = `rgba(255, 130, 0, ${pulse * 0.8})`;
  ctx.lineWidth = 2.5;
  ctx.beginPath();
  ctx.arc(sx, sy, 16, 0, Math.PI * 2);
  ctx.stroke();

  // Core dot
  ctx.fillStyle = `rgba(255, 180, 60, ${pulse})`;
  ctx.beginPath();
  ctx.arc(sx, sy, 7, 0, Math.PI * 2);
  ctx.fill();

  // Label
  ctx.font = "bold 10px sans-serif";
  ctx.textAlign = "center";
  ctx.strokeStyle = "rgba(0, 0, 0, 0.8)";
  ctx.lineWidth = 3;
  ctx.strokeText("BOMB", sx, sy - 22);
  ctx.fillStyle = `rgba(255, 200, 100, ${pulse * 0.9})`;
  ctx.fillText("BOMB", sx, sy - 22);
}

export function drawDroppedBomb(
  ctx: CanvasRenderingContext2D,
  bombDrops: BombDropEvent[],
  bombsPlanted: BombPlantedEvent[],
  bombPickupTicks: number[],
  frameTick: number,
  toScreenX: (x: number) => number,
  toScreenY: (y: number) => number
) {
  // Find the most recent drop at or before this frame tick
  const pastDrops = bombDrops.filter((d) => d.tick <= frameTick);
  if (pastDrops.length === 0) return;
  const drop = pastDrops[pastDrops.length - 1];

  // The bomb is only on the ground between the drop and the next pickup or plant.
  const clearedByPickup = bombPickupTicks.some((t) => t > drop.tick && t <= frameTick);
  const clearedByPlant = bombsPlanted.some((p) => p.tick > drop.tick && p.tick <= frameTick);
  if (clearedByPickup || clearedByPlant) return;

  const sx = toScreenX(drop.x);
  const sy = toScreenY(drop.y);

  // Static (non-pulsing) smaller marker to distinguish from planted bomb
  ctx.fillStyle = "rgba(255, 130, 0, 0.15)";
  ctx.beginPath();
  ctx.arc(sx, sy, 16, 0, Math.PI * 2);
  ctx.fill();

  ctx.strokeStyle = "rgba(255, 130, 0, 0.7)";
  ctx.lineWidth = 2;
  ctx.setLineDash([4, 3]);
  ctx.beginPath();
  ctx.arc(sx, sy, 10, 0, Math.PI * 2);
  ctx.stroke();
  ctx.setLineDash([]);

  ctx.fillStyle = "rgba(255, 180, 60, 0.9)";
  ctx.beginPath();
  ctx.arc(sx, sy, 4, 0, Math.PI * 2);
  ctx.fill();

  ctx.font = "bold 9px sans-serif";
  ctx.textAlign = "center";
  ctx.strokeStyle = "rgba(0, 0, 0, 0.8)";
  ctx.lineWidth = 3;
  ctx.strokeText("C4", sx, sy - 16);
  ctx.fillStyle = "rgba(255, 200, 100, 0.9)";
  ctx.fillText("C4", sx, sy - 16);
}
